import Vue from 'vue';

Vue.filter('money', (value = 0) => {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
});

Vue.filter('validUrl', (value = '') => {
    if (value.length === 0 || value.startsWith('http')) {
        return value;
    }

    return 'https://' + value;
});

Vue.filter('zukunft', (text = '') => {
    if (!text || text.length === 0) {
        return text;
    }

    return text.replaceAll('Zukunft', '<i>Zukunft</i>').replaceAll('zukunft', '<i>zukunft</i>');
});
